import { ManageAccounts, Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import { useState } from 'react';
import {
    Button,
    Modal,
    Box,
    CircularProgress,
    Typography,
    Grid,
    Autocomplete,
    Select,
    MenuItem,
    Checkbox,
    TextField,
    FormControl
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import { successAlert } from 'ui-component/Toasts';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const UpdatePayment = ({ paymentList, fetchPayment, statusList, thirdPartyList }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [amount, setamount] = useState(paymentList.amount ? paymentList.amount : '');
    const [status, setStatus] = useState(paymentList.statusName ? paymentList.statusName : '');
    const [thirdParty, setThirdParty] = useState(paymentList.thirdPartyName ? paymentList.thirdPartyName : '');

    console.log('Testing', status, thirdParty);

    const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
    const [UpdatePaymentListLoading, setUpdatePaymentListLoading] = useState(false);

    const submitInsertTasklist = async () => {
        setUpdateBtnDisabled(true);
        setTimeout(() => {
            setUpdateBtnDisabled(false);
        }, 3000);
        setUpdatePaymentListLoading(true);
        try {
            const res = await axiosInstance.put(
                '/Payment',
                {
                    id: paymentList.id,
                    amount: amount,
                    thirdPartyID: thirdParty,
                    statusID: status
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Shop Purchase Updated successfully.');
                fetchPayment();
                setOpen(false);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdatePaymentListLoading(false);
        }
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ManageAccounts />
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {UpdatePaymentListLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Update Payment
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Amount :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={amount}
                                            onChange={(e) => setamount(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Status :
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Select
                                                displayEmpty
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem value={''}>Select Status</MenuItem>
                                                {statusList.map((item, index) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Third Party :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={thirdParty}
                                                onChange={(e) => setThirdParty(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value={""}>
                                                    Select ThirdParty
                                                </MenuItem>
                                                {thirdPartyList.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => submitInsertTasklist()}
                            disabled={updateBtnDisabled}
                        >
                            Update
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default UpdatePayment;
